import React from 'react';
import { Box, Typography } from '@mui/material';
import CommonImages from '../../../commons/images';
import * as styles from './styles';

function BrandSpace() {
    return (
        <Box sx={styles.brandCol}>
            <Box
                component="img"
                src={CommonImages.ECAL_SYMBOL}
                alt="ECAL"
                sx={styles.brandLogo}
            />
            <Typography sx={styles.brandTagline}>
                ECAL is the world's leading calendar marketing platform, connecting
                brands to their audiences at exactly the right moment.
            </Typography>
        </Box>
    );
}

export default BrandSpace;
